import moment from "moment";
import AppConfig from "./AppConfig.json";

export function getCardNo(profile) {
  return profile?.cards?.length ? profile.cards[0].cardNo : "-";
}

export const isT1X = (memberData) => {
  let isT1X = false;

  try {
    const { tiers } = memberData;
    if (tiers) {
      for (let s in tiers) {
        if (tiers[s].code === "T1X") {
          if (tiers[s].expiryDate) {
            const isExpire = moment(
              tiers[s].expiryDate,
              "YYYY-MM-DDTHH:mm:ss[Z]"
            ).isBefore(moment());
            isT1X = !isExpire;
          } else {
            isT1X = true;
          }
          break;
        }
      }
    }
  } catch (e) {
    // console.error(e)
  }

  return isT1X;
};

export function isMissionStickerCampaign() {
  let startDate = moment("2022-07-12 09:00:00+7:00", "YYYY-MM-DD HH:mm:ssz");
  let endDate = moment("2022-10-9 22:00:00+7:00", "YYYY-MM-DD HH:mm:ssz");
  let isInPeriod = moment().isAfter(startDate) && moment().isBefore(endDate);
  // console.log(AppConfig.env)
  // console.log(startDate)
  // console.log(endDate)
  // console.log(isInPeriod)
  return AppConfig.env === "prod" && isInPeriod;
}

export const formatter = {
  email: (value) => value.trim().toLowerCase(),
  fullMobile: (mobile) => {
    const { country, value } = formatter.mobile(mobile);

    return `${country}${value}`;
  },
  mobile: (mobile) => {
    mobile.country = mobile.country || "66";
    const cnt = mobile.country.trim().replace("+", "");

    const country = cnt.length === 0 ? "66" : cnt;
    let val = mobile.value.replace(/-|\s/gi, "");

    if (country === "66" && val.length !== 9) {
      val = val.replace(/^(66)(.+)/, "$2");
    }

    let offset = true;
    let value = "";

    for (const char of val) {
      if (!offset || char !== "0") {
        offset = false;
        value += char;
      }
    }

    return { country, value };
  },
};
